import { render, staticRenderFns } from "./FavoritesButton.vue?vue&type=template&id=3865c3cd&"
import script from "./FavoritesButton.vue?vue&type=script&lang=js&"
export * from "./FavoritesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports